<h1>Enroll</h1>

@if (sub.maxAllowedUniqueDealerTechnicianLogins > 0 || fleet) {
  <section>
    <p>Clicking "Enroll Now" below will subscribe you to the Ford Diagnostic Enrollment Program.</p>
    @if(fleet) {
      <p style="text-align: right;">Yearly Cost Per Subscription: ${{fleetPrice.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
      <br>Current Monthly Billing Amount: ${{fleetMonthly.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}</p>
    } @else {
      <p style="text-align: right;">Yearly Cost Per Subscription: ${{price.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
      <br>Current Monthly Billing Amount: ${{monthly.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}</p>
    }
    <ul>
      @if (fleet) {
        <li>FIN Code: {{dealer.pa_code}}</li>
      } @else {
        <li>PA Code: {{dealer.pa_code}}</li>
      }
      @if(fleet) {
        <li>@if(countUpdated) {
          *
        }
          Number of Subscriptions: {{sub.maxAllowedUniqueDealerTechnicianLogins == null ? dealerStatus.tech_count == null ? 0 : dealerStatus.tech_count.toLocaleString() : sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}</li>
          <!-- Number of Subscriptions: {{dealerStatus.tech_count == null ? sub.maxAllowedUniqueDealerTechnicianLogins == null ? 0 : sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString() : dealerStatus.tech_count.toLocaleString()}}</li> -->
      } @else {
        <!-- <li>Number of Service Technicians: {{sub.maxAllowedUniqueDealerTechnicianLogins == null ? 0 : sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}</li> -->
        <li>Number of Service Technicians: {{dealerStatus.tech_count == null ? sub.maxAllowedUniqueDealerTechnicianLogins == null ? 0 : sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString() : dealerStatus.tech_count.toLocaleString()}}</li>
      }      
      <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.</li>
      <!-- <li>**Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}} maximum.</li> -->
    @if(fleet && countUpdated) {
      <p style="font-size: 12px;">*Defaulting the subscription count to 1 as there are no active subscriptions available.</p>
    }
    <!-- <p style="font-size: 12px;">**If a tech is working on multiple vehicles.</p> -->
    </ul>    
    <p><button (click)="addSubscription()">Enroll Now</button>
  </section>
}

@if (!sub.maxAllowedUniqueDealerTechnicianLogins && !fleet) {
  <section>
    <h3>No Technicians Found</h3>
    <p>Please <a href="/contact">contact us</a> to set the number of service technicians needed to access the Ford Diagnostic Subscription system.
  </section>
}
